/* eslint-disable no-console */
function message(fn, scope, ...args) {
    fn('[oswald:%s]:', scope, ...args);
}
function scopedDebugMessage(scope, ...args) {
    return message(console.debug, scope, ...args);
}
function scopedErrorMessage(scope, ...args) {
    return message(console.error, scope, ...args);
}
function scopedWarningMessage(scope, ...args) {
    return message(console.warn, scope, ...args);
}
export { scopedDebugMessage, scopedErrorMessage, scopedWarningMessage, };
//# sourceMappingURL=scoped-messages.js.map